enum MeetingEvent {
    VideoAdded = 'video-added',
    VideoRemoved = 'video-removed',
    PlaceholderAdded = 'placeholder-added',
    PlaceholderRemoved = 'placeholder-removed',
    ScreenshareAdded = 'screenshare-added',
    ScreenshareRemoved = 'screenshare-removed',
    CommandReceived = 'command-received',
    FailoverChanged = 'failover-changed',
    ConnectionFailed = 'connection-failed',
    CameraChanged = 'camera-changed',
    Initialized = 'initialized',
    AudioStreamInterruped = 'audio-stream-interrupted',
    UserNotResponding = 'user-not-responding',
    UserResponding = 'user-responding',
	DestroyedPermanently = "destroyed-permanently",
}
export { MeetingEvent };